import React from 'react';
import Box from '@mui/material/Box';
import { GlobalStyles } from '@mui/material';
import { PagesContentContext } from '../Hooks/usePagesContent';
import { useSelector } from 'react-redux';

function ScreenContainer({ children, pagesContent }) {
    const timezoneChanged = useSelector((state) => state.TimeZoneChanged.value);

    return (
        <PagesContentContext.Provider value={pagesContent}>
            <Box
                key={timezoneChanged}
                sx={{
                    fontFamily: 'Roboto',
                    WebkitFontSmoothing: 'antialiased',
                    MozOsxFontSmoothing: 'grayscale',
                    backgroundColor: '#FAFAFA',
                    height: '100%',
                    marginTop: '50px', // Adjusted for AppBar
                    marginLeft: '55px', // Adjusted for SideBar
                }}
            >
                {/* https://www.notion.so/coulombai/Remove-global-body-scroll-from-the-frontend-app-1e0a49b8180a80a78de0e357dc205108 */}
                <GlobalStyles styles={{
                    body: {
                        overflow: 'scroll',
                        '&::-webkit-scrollbar': { display: 'none !important' }
                    }
                }} />
                {children}
            </Box>
        </PagesContentContext.Provider>
    );
}

export default ScreenContainer;
